import React from "react"
import { NativeSelect, InputBase, withStyles } from "@material-ui/core"
import { Error } from '../layout/Error'
import { map } from 'lodash'

export const Dropdown = ({fieldProps, label, options, children, onChange, ...props}) => {
    const { fieldState: { isTouched, error } } = fieldProps
    const { field } = fieldProps

    const localOnChange = (v) => {
        field.onChange(v)
        if ( onChange ) {
            onChange(v)
        }
    }
    
    return (
        <>
          <NativeSelect inputRef={field.ref}
                        onChange={localOnChange}
                        value={field.value}
                        disableUnderline
                        style={{
                            background: "white",
                            borderRadius: 8,
                            width: "100%",
                        }}
                        input={<BootstrapInput />}
          >
            {map(options, (item) => (
                <option value={item.value} key={item.value}>
                  {item.label}
                </option>
            ))}
          </NativeSelect>
          
          { error && <Error>{error.message}</Error> }
        </>
    )
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(3),
        },
        "& .MuiNativeSelect-icon": {
            color: "#7a7a76",
            background: "white",
            border: "none",
            outline: "none",
            boxShadow: "none",
            right: 7,
        },
        "& .MuiNativeSelect-select": {
            borderRight: "none",
        },
    },
    input: {
        borderRadius: 8,
        position: "relative",
        backgroundColor: "white",
        border: "1px solid #d6e2ef",
        fontSize: 12.5,
        fontWeight: 600,
        color: "#0b3556",
        padding: "7px 28px 7px 12px",
        height: "auto",
        lineHeight: "1.4",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        "&:hover": {
            borderColor: "#3a86d8",
        },
        "&:focus": {
            borderColor: "#3a86d8",
            boxShadow: "0 0 0 3px #e7f0fa",
            borderRadius: 8,
            backgroundColor: "white",
        },
    },
}))(InputBase)
